import {
  INVALIDATE_CLIENT,
  INVALIDATE_PLAN_COMPTABLE,
  INVALIDATE_DEPENSES,
  INVALIDATE_VENTES,
  INVALIDATE_CREANCES,
  INVALIDATE_DETTES,
  INVALIDATE_ECRITURE,
  INVALIDATE_LIVRE_JOURNAL,
  INVALIDATE_TRANSACTIONS,
} from 'actions/invalidationTags';
import { ApiMananger } from "actions/rtkquery";
import {
  ADD_ECRITURE_MANUELLE,
  CLEANUP_ORPHAN_ECRITURES,
  CORRIGER_BILAN_COMPTABLE,
  ECRITURES_MULTILIGNES,
  IMPORT_ECRITURES,
  RECONSTRUCTION_COMPTABLE,
  WORKFLOW_ECRITURE_MANUELLE,
} from "routes/api/endpoints";

const INITIALISER_PLAN_COMPTABLE = process.env.REACT_APP_API_URL + '/comptable/initialiser/';

const comptabiliteMutationsApi = ApiMananger.injectEndpoints({
  endpoints: (build) => ({
    // Initialiser le plan comptable (SYSCOHADA + Personnalisés)
    initialiserPlanComptable: build.mutation({
      query: (body) => ({
        url: INITIALISER_PLAN_COMPTABLE,
        method: "POST",
        body,
      }),
      invalidatesTags: [INVALIDATE_CLIENT, INVALIDATE_PLAN_COMPTABLE, INVALIDATE_DEPENSES, INVALIDATE_VENTES, INVALIDATE_CREANCES, INVALIDATE_DETTES, INVALIDATE_ECRITURE, INVALIDATE_LIVRE_JOURNAL],
    }),
    createEcritureManuelle: build.mutation({
      query: (body) => ({
        url: ADD_ECRITURE_MANUELLE,
        method: "POST",
        body,
      }),
      invalidatesTags: [INVALIDATE_CLIENT, INVALIDATE_DEPENSES, INVALIDATE_VENTES, INVALIDATE_TRANSACTIONS, INVALIDATE_CREANCES, INVALIDATE_DETTES, INVALIDATE_ECRITURE, INVALIDATE_LIVRE_JOURNAL],
    }),
    createEcritureMultilignes: build.mutation({
      query: (body) => ({
        url: ECRITURES_MULTILIGNES,
        method: "POST",
        body,
      }),
      invalidatesTags: [INVALIDATE_CLIENT, INVALIDATE_PLAN_COMPTABLE, INVALIDATE_DEPENSES, INVALIDATE_VENTES, INVALIDATE_TRANSACTIONS, INVALIDATE_CREANCES, INVALIDATE_DETTES, INVALIDATE_ECRITURE, INVALIDATE_LIVRE_JOURNAL],
    }),
    deletePieceMultilignes: build.mutation({
      query: (body) => ({
        url: ECRITURES_MULTILIGNES,
        method: "DELETE",
        body,
      }),
      invalidatesTags: [INVALIDATE_CLIENT, INVALIDATE_PLAN_COMPTABLE, INVALIDATE_DEPENSES, INVALIDATE_VENTES, INVALIDATE_TRANSACTIONS, INVALIDATE_CREANCES, INVALIDATE_DETTES, INVALIDATE_ECRITURE, INVALIDATE_LIVRE_JOURNAL],
    }),
    importEcritures: build.mutation({
      query: (formData) => ({
        url: IMPORT_ECRITURES,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: [INVALIDATE_CLIENT, INVALIDATE_PLAN_COMPTABLE, INVALIDATE_DEPENSES, INVALIDATE_VENTES, INVALIDATE_TRANSACTIONS, INVALIDATE_CREANCES, INVALIDATE_DETTES, INVALIDATE_ECRITURE, INVALIDATE_LIVRE_JOURNAL],
    }),
    corrigerBilanComptable: build.mutation({
      query: (body) => ({
        url: CORRIGER_BILAN_COMPTABLE,
        method: "POST",
        body,
      }),
      invalidatesTags: [INVALIDATE_CLIENT],
    }),
    reconstructionComptable: build.mutation({
      query: (body) => ({
        url: RECONSTRUCTION_COMPTABLE,
        method: "POST",
        body,
      }),
      invalidatesTags: [INVALIDATE_CLIENT],
    }),
    workflowEcritureManuelle: build.mutation({
      query: ({ ecriture_id, action }) => ({
        url: `${WORKFLOW_ECRITURE_MANUELLE}${ecriture_id}/workflow/`,
        method: "POST",
        body: { action },
      }),
      invalidatesTags: [INVALIDATE_CLIENT, INVALIDATE_DEPENSES, INVALIDATE_VENTES, INVALIDATE_TRANSACTIONS, INVALIDATE_CREANCES, INVALIDATE_DETTES, INVALIDATE_ECRITURE, INVALIDATE_LIVRE_JOURNAL],
    }),
    updateEcritureManuelle: build.mutation({
      query: ({ ecriture_id, ...body }) => ({
        url: `${ADD_ECRITURE_MANUELLE}${ecriture_id}/`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: [INVALIDATE_CLIENT, INVALIDATE_DEPENSES, INVALIDATE_VENTES, INVALIDATE_TRANSACTIONS, INVALIDATE_CREANCES, INVALIDATE_DETTES, INVALIDATE_ECRITURE, INVALIDATE_LIVRE_JOURNAL],
    }),
    deleteEcritureManuelle: build.mutation({
      query: ({ ecriture_id }) => ({
        url: `${ADD_ECRITURE_MANUELLE}${ecriture_id}/`,
        method: "DELETE",
      }),
      invalidatesTags: [INVALIDATE_CLIENT, INVALIDATE_DEPENSES, INVALIDATE_VENTES, INVALIDATE_TRANSACTIONS, INVALIDATE_CREANCES, INVALIDATE_DETTES, INVALIDATE_ECRITURE, INVALIDATE_LIVRE_JOURNAL],
    }),
    cleanupOrphanEcritures: build.mutation({
      query: (body) => ({
        url: CLEANUP_ORPHAN_ECRITURES,
        method: "POST",
        body,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useInitialiserPlanComptableMutation,
  useCreateEcritureManuelleMutation,
  useCreateEcritureMultilignesMutation,
  useDeletePieceMultilignesMutation,
  useImportEcrituresMutation,
  useCorrigerBilanComptableMutation,
  useReconstructionComptableMutation,
  useWorkflowEcritureManuelleMutation,
  useUpdateEcritureManuelleMutation,
  useDeleteEcritureManuelleMutation,
  useCleanupOrphanEcrituresMutation,
} = comptabiliteMutationsApi;
